import { CaseType, PhysiotherapyOriginType } from "@teamprevent/common/model";

import { routes as customerUsers } from "./crud/customerUser";
import { routes as OhCase } from "./crud/ohCase";
import { routes as actionableTasks } from "./actionableTask/routes";
import { routes as documents } from "./documents";
import { routes as assessmentAndWellBeing } from "./assessmentAndWellBeing";

export const routes: any = {
    "/": {
        title: "Home",
    },
    "/login": {
        title: "Login"
    },
    "/referral": {
        title: "Referral",
        requiredProducts: [CaseType.REFERRAL]
    },
    "/ppq": {
        title: "PPQ",
        requiredProducts: [CaseType.PPQ]
    },
    ...actionableTasks,
    ...customerUsers,
    ...OhCase,
    "/statistics": {
        title: "statistics"
    },
    "/physiotherapy": {
        title: "Physiotherapy",
        requiredProducts: [CaseType.PHYSIOTHERAPY_REFERRAL],
        physioOrigins: [PhysiotherapyOriginType.REFERRAL]
    },
    "/otherServices": {
        title: "Other Services",
        requiredProducts: [CaseType.GENERIC],
    },
    ...documents,
    ...assessmentAndWellBeing
};
